import { render, staticRenderFns } from "./Confirmcao.vue?vue&type=template&id=2b62c60f&scoped=true&"
import script from "./Confirmcao.vue?vue&type=script&lang=js&"
export * from "./Confirmcao.vue?vue&type=script&lang=js&"
import style0 from "./Confirmcao.vue?vue&type=style&index=0&id=2b62c60f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b62c60f",
  null
  
)

export default component.exports